






























import { Component, Vue } from 'vue-property-decorator';
import { ISenderUpdate } from '@/interfaces';
import VSelectWithValidation from '@/components/VSelectWithValidation.vue';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import { dispatchGetSender, dispatchUpdateSender, readOneSender } from '@/store/admin/accessors';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
  },
})
export default class EditSender extends Vue {
  public valid = true;
  public name: string = '';
  public blockInternational: boolean = false;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public async mounted() {
    await dispatchGetSender(this.$store, Number(this.$router.currentRoute.params.id));
    this.reset();
  }

  public reset() {
    this.$refs.observer.reset();
    if (this.sender) {
      this.name = this.sender.name;
      this.blockInternational = this.sender.block_international;
    }
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const updatedSender: ISenderUpdate = {};
      updatedSender.name = this.name;
      updatedSender.block_international = this.blockInternational;
      const result = await dispatchUpdateSender(this.$store, {
        id: this.sender!.id,
        sender: updatedSender,
      });
      if (result) {
        this.$router.push('/main/admin/senders');
      }
    }
  }

  get sender() {
    return readOneSender(this.$store)(+this.$router.currentRoute.params.id);
  }
}
